import { z } from "zod"

import { powurOsResponseSchema } from "./base"
import { powurOsEquipmentSchema } from "../models"

export const getEquipmentResponseSchema = powurOsResponseSchema.extend({
  model: z.array(powurOsEquipmentSchema),
})
export type GetEquipmentResponse = z.infer<typeof getEquipmentResponseSchema>
